/* eslint-disable */

// 来源于网络 有细微改动

import './_blob'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import XLSXStyle from 'xlsx-style'

function generateArray(table) {
    var out = [];
    var rows = table.querySelectorAll('tr');
    var ranges = [];
    for (var R = 0; R < rows.length; ++R) {
        var outRow = [];
        var row = rows[R];
        var columns = row.querySelectorAll('td');
        for (var C = 0; C < columns.length; ++C) {
            var cell = columns[C];
            var colspan = cell.getAttribute('colspan');
            var rowspan = cell.getAttribute('rowspan');
            var cellValue = cell.innerText;
            if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

            //Skip ranges
            ranges.forEach(function (range) {
                if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                    for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
                }
            });

            //Handle Row Span
            if (rowspan || colspan) {
                rowspan = rowspan || 1;
                colspan = colspan || 1;
                ranges.push({s: {r: R, c: outRow.length}, e: {r: R + rowspan - 1, c: outRow.length + colspan - 1}});
            }
            ;

            //Handle Value
            outRow.push(cellValue !== "" ? cellValue : null);

            //Handle Colspan
            if (colspan) for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
        }
        out.push(outRow);
    }
    return [out, ranges];
};

function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}
function isNumeric(str){
    if(typeof str === 'number'){
        return true
    }
    return !isNaN(parseFloat(str))&& isFinite(str);
}
function sheet_from_array_of_arrays(data, opts) {
    var ws = {};
    var range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}};
    for (var R = 0; R != data.length; ++R) {
        for (var C = 0; C != data[R].length; ++C) {
            if (range.s.r > R) range.s.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.r < R) range.e.r = R;
            if (range.e.c < C) range.e.c = C;
            var cell = {v: data[R][C]};
            if (cell.v == null) continue;
            var cell_ref = XLSX.utils.encode_cell({c: C, r: R});

            // 是字符串数字，但是数字不大，就转化为数字
            if(isNumeric(cell.v) && Math.abs(Number(cell.v)) <= Number.MAX_SAFE_INTEGER) {
                cell.t = 'n';
                cell.v = Number(cell.v);

            // 是字符串数字，但是数字超大，就转化为字符串
            } else if(isNumeric(cell.v)) {
                cell.t = 's';
                cell.v = String(cell.v);

            // 是布尔类型
            } else if (typeof cell.v === 'boolean') {
                cell.t = 'b';

            // 是日期类型
            } else if (cell.v instanceof Date) {
                cell.t = 'n';
                cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);

            // 是字符串类型
            } else {
                cell.t = 's';
                // 有些时候虽然传过来的数据是字符串，但这个函数依然会判断它能不能转化成数字，如果能，它就会去转化
                // 只有当有些数据转化成数字会特别长的时候，它才会把它们保持为字符串
                // 那么问题来了，如果有些字符串不是很长，但我们依然需要它保持为字符串呢？
                // 如果说想要不破坏原有逻辑，又不想改动过多造成风险的时候，那就只能专门处理一下这个数据本身了
                // 给不想要转化成数字的数据前面拼接一个“keepString”前缀，它就无法被上面的逻辑给转化了
                // 然后判断逻辑就自然走到了这里，然后在这里将这个前缀删掉就行
                // 方法不是很正统，但很好用，风险也很低
                if (cell.v.slice(0, 10) === 'keepString') {
                    cell.v = cell.v.slice(10)
                }
            }

            ws[cell_ref] = cell;
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
}

function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

export function export_table_to_excel(id) {
    var theTable = document.getElementById(id);
    console.log('a')
    var oo = generateArray(theTable);
    var ranges = oo[1];

    /* original data */
    var data = oo[0];
    var ws_name = "SheetJS";
    console.log(data);

    var wb = new Workbook(), ws = sheet_from_array_of_arrays(data);

    /* add ranges to worksheet */
    // ws['!cols'] = ['apple', 'banan'];
    ws['!merges'] = ranges;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: false, type: 'binary'});

    FileSaver.saveAs(new Blob([s2ab(wbout)], {type: "application/octet-stream"}), "test.xlsx")
}

function formatJson(jsonData) {
    console.log(jsonData)
}
export function export_json_to_excel(th, jsonData, defaultTitle, defaultHeader = '') {

    /* original data */

    var data = jsonData;
    data.unshift(th);

    // 判断有没有传入表头参数, 如果有, 就把表头数据插入
    if (defaultHeader) {
        data.unshift([defaultHeader]);
    }

    var ws_name = "SheetJS";

    var wb = new Workbook(), ws = sheet_from_array_of_arrays(data);

    // 设置每一个单元格的字体为宋体
    Object.keys(ws).forEach(key => {
        if (key !== '!merges' && key !== '!ref') {
            ws[key].s = {
                font: { name: '宋体' }
            }
        }
    })

    // 控制表头单元格合并, 并将对齐方式调整为居中
    if (defaultHeader) {
        ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: th.length - 1 } }];
        ws['A1'].s = {
            alignment: { horizontal: 'center', vertical: 'center' },
            font: { name: '宋体', sz: 18 }
        };
    }

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = XLSXStyle.write(wb, {bookType: 'xlsx', bookSST: false, type: 'binary', cellStyles: true });
    var title = defaultTitle || '列表'
    FileSaver.saveAs(new Blob([s2ab(wbout)], {type: "application/octet-stream"}), title + ".xlsx")
}
